export const LOGO_ICON = "https://static.prod-images.emergentagent.com/jobs/68b169ca-f399-489b-93de-bf7a5cb1d144/images/2b9bfcf8e74bf196f4345491394d5fc9e200bf4fcb73e6f2acdf51f6346cd78e.png";
export const LOGO_FULL = "https://customer-assets-eiarnc6j.emergentagent.net/job_heartflow-gel-design/artifacts/ag6paixb_logo%202%20.png";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1691933880037-ce9d151ab922?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  machine: "https://images.unsplash.com/photo-1691935071222-c008a4ccc2ca?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  fourChamber: "https://static.prod-images.emergentagent.com/jobs/68b169ca-f399-489b-93de-bf7a5cb1d144/images/81039dd8453b092d9f02284796d2458cd886568d47300a018b5054e88e526d22.png",
  screening: "https://images.pexels.com/photos/30367056/pexels-photo-30367056.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  eventEngage1: "https://customer-assets-eiarnc6j.emergentagent.net/job_heartflow-gel-design/artifacts/ybcpwrj3_IMG_7317.webp",
  eventEngage2: "https://customer-assets-eiarnc6j.emergentagent.net/job_heartflow-gel-design/artifacts/64ci15eg_IMG_7324.webp",
  eventBooth: "https://customer-assets-eiarnc6j.emergentagent.net/job_heartflow-gel-design/artifacts/pjhn9jag_IMG_2518.webp",
  monitor: "https://images.unsplash.com/photo-1513224502586-d1e602410265?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  consult: "https://static.prod-images.emergentagent.com/jobs/68b169ca-f399-489b-93de-bf7a5cb1d144/images/df6e6b0ba2dc336af8e0c8d7687b9651736f8d42b69a1eec213b7fe007f61fbe.png",
  sonographer: "https://images.unsplash.com/photo-1691933880113-3c0d20a48451?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const HOW_STEPS = [
  { title: "Schedule a Service Day", desc: "Partner with Cardiac Precision Diagnostics to schedule on-site echocardiography services at your practice. We work with your office to create a schedule that fits your patients' needs." },
  { title: "We Come to Your Office", desc: "Our Registered Cardiac Sonographer arrives with portable echocardiography equipment and performs high-quality diagnostic studies in the comfort of your office, eliminating the need for patients to travel elsewhere." },
  { title: "Expert Interpretation", desc: "Completed studies are securely transmitted to a board-certified cardiologist for timely interpretation." },
  { title: "Results Delivered Promptly", desc: "The finalized echocardiogram report is securely returned to the ordering provider for review, treatment planning, and follow-up with the patient." },
  { title: "Continued Patient Care", desc: "Your practice maintains continuity of care while offering patients convenient access to diagnostic cardiac imaging without leaving your office." },
];

export const SERVICES = [
  {
    title: "Mobile Echocardiography for Medical Practices",
    desc: "Bring echocardiography directly to your practice. A Registered Cardiac Sonographer performs ordered transthoracic echocardiograms (TTEs) on-site using professional portable cardiac ultrasound equipment.",
    icon: "HeartPulse",
  },
  {
    title: "Know Your Heart™ Cardiac Screening",
    desc: "An accessible $300 self-pay cardiac screening option that includes a complete echocardiogram, professional cardiologist interpretation, and results sent to the participant's designated primary care provider.",
    icon: "Heart",
  },
  {
    title: "Community Heart Health Outreach",
    desc: "Bring heart-health education and screening opportunities to your organization through community events, employee wellness programs, churches, senior communities, health fairs, and other group settings.",
    icon: "HeartHandshake",
  },
];

export const WHY = [
  "Registered Cardiac Sonographer (RCS)",
  "Mobile, on-site echocardiography",
  "Advanced portable ultrasound equipment",
  "Timely, flexible scheduling",
  "High-quality diagnostic imaging",
  "HIPAA-compliant workflow",
  "Secure image transmission",
  "Board-certified cardiologist interpretation",
  "Personalized, patient-centered service",
  "Commitment to clinical excellence",
];

export const VALUES = [
  "Clinical Excellence", "Integrity", "Compassion", "Professionalism",
  "Reliability", "Patient-Centered Care", "Innovation", "Collaboration",
];

export const AREAS = [
  { city: "Houston", note: "Serving physician offices & clinics across the metro." },
  { city: "Katy", note: "On-site echo for practices throughout Katy." },
  { city: "Sugar Land", note: "Mobile cardiac imaging for Fort Bend County." },
  { city: "Richmond", note: "On-site echocardiography for Richmond-area practices." },
  { city: "Pearland", note: "Serving physician offices & clinics across Pearland." },
  { city: "Surrounding Areas", note: "Extending coverage across Greater Houston." },
];

export const FAQS = [
  { q: "What is a mobile echocardiogram service?", a: "We bring advanced portable ultrasound equipment and a Registered Cardiac Sonographer directly to your physician office, clinic, or facility to perform comprehensive echocardiograms on-site — eliminating the need to refer patients to outside imaging centers." },
  { q: "Who performs the echocardiograms?", a: "All exams are performed by an experienced Registered Cardiac Sonographer (RCS) following nationally recognized standards to ensure high-quality, diagnostic images." },
  { q: "How are studies interpreted?", a: "Diagnostic images are securely transmitted via a HIPAA-compliant workflow for professional interpretation by board-certified cardiologists, ensuring accurate and timely diagnostic reports." },
  { q: "Which facilities do you partner with?", a: "Private physician practices, cardiology clinics, primary care offices, skilled nursing facilities, occupational health providers, and community health organizations." },
  { q: "What areas do you serve?", a: "We serve Houston, Katy, Sugar Land, and surrounding areas throughout Greater Houston, Texas." },
  { q: "Is the service HIPAA-compliant?", a: "Yes. Every examination and image transmission is performed in strict compliance with HIPAA regulations and industry best practices." },
];

export const EVENTS = [
  {
    id: "fb-expo-2026",
    title: "Fort Bend Health & Wellness EXPO",
    date: "Thursday, October 8, 2026",
    time: "5:00 PM–7:00 PM",
    location: "St. Luke's Sugar Land Hospital · 1317 Lake Pointe Parkway, Sugar Land, TX 77478",
    desc: "Cardiac Precision Diagnostics, LLC will be exhibiting at the Fort Bend Health & Wellness EXPO. Visit our booth to meet us and learn more about our cardiac ultrasound services and community heart-health initiatives.",
    link: "",
    expiresAt: "2026-10-08T23:59:00-05:00",
  },
  {
    id: "rooted-in-wellness-2026",
    title: "Rooted in Wellness: Community Health Fair",
    date: "Saturday, October 17, 2026",
    time: "10:00 AM–1:00 PM",
    location: "Fifth Ward Multi-Service Center · Houston, Texas",
    desc: "Cardiac Precision Diagnostics, LLC will be participating as a community health vendor. Stop by our booth to meet us and learn more about our cardiac ultrasound services and community heart-health initiatives.",
    link: "https://www.eventbrite.com/e/rooted-in-wellness-community-health-fair-tickets-1998459266463",
    expiresAt: "2026-10-17T23:59:00-05:00",
  },
];

export const PARTNER_VALUES = [  { title: "Convenient Access", quote: "Having mobile echocardiography available onsite can help practices streamline cardiac evaluations and improve patient convenience." },
  { title: "Quality & Collaboration", quote: "Our goal is to support providers with diagnostic-quality imaging and efficient communication throughout the referral process." },
  { title: "Patient-Centered Experience", quote: "We strive to create a comfortable, professional experience while helping patients receive timely cardiac evaluations." },
];
